import store from '@/store';

/**
 * 判断用户是否拥有操作权限
 * 根据传入的权限标识，查看是否存在用户权限标识集合
 * @param perms
 */
export function hasPermission(perms) {
  const roleList = store.state.user.perms ?? [];
  return roleList.includes(perms);
}

export default {
  bind(el, binding) {
    if (binding.value === undefined || binding.value.length === 0) return;
    if (!hasPermission(binding.value)) {
      el.style.display = 'none';
      el.remove();
    }
  }
};
